import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { AccountService } from './account.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GaugingFull, SpecialGauge, Totals } from '../interfaces/gauging.interface';

@Injectable({
  providedIn: 'root',
})
export class GaugingService {
  private url = `${environment.api_url}/aforo/app`;
  private gauging_data: GaugingFull | null = null;

  constructor(private http: HttpClient, private accountSrv: AccountService) {}

  deleteFile(id: number): Observable<any> {
    let headers = this.accountSrv.headers;
    return this.http.delete<any>(`${this.url}/gauging/delete_file/${id}/`, {
      headers,
    });
  }

  downloadGaugingReport(gauging_id: number): Observable<any> {
    let headers = this.accountSrv.headers;
    let data = `?gauging=${gauging_id}`;
    return this.http.get<any>(`${this.url}/gauging/report/${data}`, {
      headers,
    });
  }

  downloadVoucher(gauge_id: number): Observable<any> {
    let headers = this.accountSrv.headers;
    let data = `?gauge=${gauge_id}`;
    return this.http.get<any>(`${this.url}/special_gauge/voucher/${data}`, {
      headers,
    });
  }

  formGauging(data: any, id?: number): Observable<any> {
    let headers = this.accountSrv.headers;
    return !id
      ? this.http.post<any>(`${this.url}/gauging/`, data, { headers })
      : this.http.patch<any>(`${this.url}/gauging/${id}/`, data, { headers });
  }

  formSpecialGauge(data: any, id?: number): Observable<any> {
    let headers = this.accountSrv.headers;
    return !id
      ? this.http.post<any>(`${this.url}/special_gauge/`, data, { headers })
      : this.http.patch<any>(`${this.url}/special_gauge/${id}/`, data, {
          headers,
        });
  }

  get gaugingData(): GaugingFull | null {
    return this.gauging_data;
  }

  getSpecialGaugesDone(flume_id: number): Observable<SpecialGauge[]> {
    let headers = this.accountSrv.headers;
    return this.http.get<SpecialGauge[]>(`${this.url}/special_gauges/done/?flume_id=${flume_id}`, { headers });
  }

  getSpecialGaugesPends(flume_id: number, micro?: string ): Observable<{
    gauges_pend: SpecialGauge[];
  }> {
    let headers = this.accountSrv.headers;
    let microParam = micro ? `&microroute=${micro}` : ''
    return this.http.get<{
      gauges_pend: SpecialGauge[];
    }>(`${this.url}/special_gauges/pending/?flume_id=${flume_id}${microParam}`, { headers });
  }

  getTodayGauging(): Observable<any> {
    let headers = this.accountSrv.headers;
    return this.http.get<any>(`${this.url}/gauging/today/`, { headers });
  }

  getTotals(): Observable<Totals> {
    let headers = this.accountSrv.headers;
    return this.http.get<Totals>(`${this.url}/gauging/totals/`, { headers });
  }

  resendGaugingReport(gauging_id: number): Observable<any> {
    let headers = this.accountSrv.headers;
    let data = `?gauging=${gauging_id}`;
    return this.http.get<any>(`${this.url}/gauging/resend_report/${data}`, {
      headers,
    });
  }

  resendVoucher(gauging_id: number): Observable<any> {
    let headers = this.accountSrv.headers;
    let data = `?gauge=${gauging_id}`;
    return this.http.get<any>(
      `${this.url}/special_gauge/resend_voucher/${data}`,
      {
        headers,
      }
    );
  }

  set gaugingData(data: GaugingFull | null) {
    this.gauging_data = data;
  }
}
